export default __webpack_public_path__ + "static/img3-669a9b3e5070c52de951c10c2837272a.jpg";